import { ProjectManager } from "@/usecases/interactors/project-manager-list-interactor";
import ProjectManagerTableItem from "@/viewmodels/project-manager-table-item";

export default function ProjectManagerTableItemDecorator(
  manager: ProjectManager
): ProjectManagerTableItem {
  return {
    id: manager.id,
    name: manager.name,
    tel: manager.tel,
    email: manager.email,
    type: manager.role.name,
    belongsTo: manager.group.name,
    isHiddenInfo: manager.isHiddenInfo,
    scheduleNotification: manager.scheduleNotification,
    projectMemberId: manager.projectMemberId as number
  };
}
